import React from "react";
import styles from "./KanbanBoard.module.scss";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import _ from "lodash";
import { useTheme } from "@material-ui/core";

import { mdiDrag } from "@mdi/js";
import Icon from "@mdi/react";

const KanbanCard = ({ item = {}, renderCardContents = () => {} }) => {
  const theme = useTheme();
  const { id } = item;

  const { setNodeRef, setActivatorNodeRef, listeners, transform, transition, isDragging } = useSortable({
    id,
    data: {
      type: "Card",
      item,
    },
  });

  const dndStyle = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      className={styles.card}
      style={{
        position: "relative",
        backgroundColor: theme.palette.background.paper,
        borderColor: theme.palette.grey[300],
        visibility: isDragging ? "hidden" : "visible",
        ...dndStyle,
      }}
    >
      {renderCardContents({
        item,
        dragHandle: <Icon path={mdiDrag} size={1} ref={setActivatorNodeRef} className={styles.dragHandle} {...listeners} />,
      })}
    </div>
  );
};

export default KanbanCard;
